"use strict"
exports.__esModule = true;
exports.OutlinedLifeRingIconConfig = {
  name: 'OutlinedLifeRingIcon',
  height: 512,
  width: 512,
  svgPath: 'M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z',
  yOffset: 0,
  xOffset: 0,
};
exports.OutlinedLifeRingIcon = require('../createIcon').createIcon(exports.OutlinedLifeRingIconConfig);
exports["default"] = exports.OutlinedLifeRingIcon;